import { i18nMark } from 'lingui-react';

export const IMPERIAL = 'Imperial';
export const METRIC = 'Metric';

export function getUnits(type) {
  if (type === METRIC) {
    return {
      distanceUnitValue: 'KILOMETERS',
      distanceUnitLabel: i18nMark('km'),
      temperatureUnitValue: 'CELCIUS',
      temperatureUnitLabel: i18nMark('C'),
      windSpeedUnitValue: 'KPH',
      windSpeedUnitLabel: i18nMark('km/h'),
    };
  }

  return {
    distanceUnitValue: 'MILES',
    distanceUnitLabel: i18nMark('mi'),
    temperatureUnitValue: 'FAHRENHEIT',
    temperatureUnitLabel: i18nMark('F'),
    windSpeedUnitValue: 'MPH',
    windSpeedUnitLabel: i18nMark('mi/h'),
  };
}

export function isMetric(type) {
  return type === METRIC;
}



// WEBPACK FOOTER //
// ./src/utils/unit.js